module.exports = __webpack_public_path__ + "static/bas_inside-b20ec97af9f6c6986cfa1fad7e1947af.jpg";